import { login } from './weblowHelpers/login'
import { signup } from './weblowHelpers/signup'

export function validateEmail(email) {
  const res = /^[\+\w-\.]+@([\w-]+\.)+[a-z]{2,4}$/
  return res.test(String(email).toLowerCase())
}

export function validateSite(site) {
  const res = /^[a-zA-Z0-9\-]+[a-zA-Z0-9]$/
  return res.test(String(site).toLowerCase())
}

export function validatePassword(pwd) {
  const res = /(.*\W.*)/
  return pwd.length >= 8 && res.test(String(pwd))
}

export function validatePhone(phone) {
  const res = /^[0-9]*$/
  return res.test(String(phone))
}

// Conditionally load webflow functions for login and signup
const conditionallyLoadWebflowFunctions = () => {
  const page = window.location.pathname

  // Check what pathname starts with
  const loginRegex = /^\/sign-in/
  const signupRegex = /^\/signup/

  if (loginRegex.test(page)) {
    login()
  } else if (signupRegex.test(page)) {
    signup()
  }
}

conditionallyLoadWebflowFunctions()
